import { useQuery, keepPreviousData } from '@tanstack/react-query';
import {
  getOrderSources,
  orderSourcesQueryKeys,
} from '@api/orderSources';
import { ApiError } from '@api/client';
import type {
  FetchOrderSourcesListParams,
  OrderSourcesListResponse,
} from '@api/orderSources';

const STALE_TIME = 30_000;

interface UseOrderSourcesOptions {
  params?: FetchOrderSourcesListParams;
  initialData?: OrderSourcesListResponse;
  enabled?: boolean;
}

export function useOrderSources({
  params = {},
  initialData,
  enabled = true,
}: UseOrderSourcesOptions = {}) {
  return useQuery({
    queryKey: orderSourcesQueryKeys.list(params),
    queryFn: () => getOrderSources(params),
    staleTime: STALE_TIME,
    placeholderData: keepPreviousData,
    enabled,
    retry: (failureCount, error) => {
      if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 3;
    },
    ...(initialData ? { initialData, initialDataUpdatedAt: Date.now() } : {}),
  });
}
